import i18n from '../../helpers/i18nMain';

const systemIPOptions = [
  {
    id: 1,
    value: 'https://ahm-qas-aen-api-mgmt.azure-api.net/sapb2bappqas',
    label: i18n.t('authScreenTranslations:AlHABTOORQAS'),
    systemName: i18n.t('authScreenTranslations:AlHABTOORQAS'),
    clientOtp: [
      {
        label: '100',
        value: '100',
      },
    ],
  },
  {
    id: 2,
    value: 'https://ahm-dev-aen-api2-mgm.azure-api.net/B2BWebAppDev',
    label: i18n.t('authScreenTranslations:AlHABTOORDEV'),
    systemName: i18n.t('authScreenTranslations:AlHABTOORDEV'),
    clientOtp: [
      {
        label: '110',
        value: '110',
      },
    ],
  },
  {
    id: 3,
    value: 'https://ahm-api-mgmt-prod.azure-api.net/sapb2bappprod',
    label: i18n.t('authScreenTranslations:AlHABTOORPRD'),
    systemName: i18n.t('authScreenTranslations:AlHABTOORPRD'),
    clientOtp: [
      {
        label: '100',
        value: '100',
      },
    ],
  },
  // {
  //   id: 5,
  //   value: 'https://stoplight.io/mocks/globalintelli/intellisoft:main/14564293',
  //   label: i18n.t('authScreenTranslations:MOCK'),
  //   systemName: 'Mock',
  //   clientOtp: [
  //     {
  //       label: '100',
  //       value: '100',
  //     },
  //   ],
  // },
];

const REDIRECT_URLS = {
  // production: 'https://ahmdevappcdn1.azureedge.net/auth', // DEV
  // production: 'https://ahmwebappb2bqas.azureedge.net/auth', // QAS
  production: 'https://partsb2b.habtoormotors.com/auth', // PRD
  development: 'http://localhost:3000/auth',
};

const msalConfig = {
  // Development: {
  // auth: {
  //   authority:
  //     'https://habtoormotorsdevb2b.b2clogin.com/habtoormotorsdevb2b.onmicrosoft.com/B2C_1_SI_B2B_DEV',
  //   knownAuthorities: ['habtoormotorsdevb2b.b2clogin.com'],
  //   clientId: 'b31f9fbd-96bd-4af3-8478-a112f7eaea73',
  //   redirectUri: REDIRECT_URLS[process.env.NODE_ENV],
  //   postLogoutRedirectUri: REDIRECT_URLS[process.env.NODE_ENV],
  // },
  // },
  // QAS: {
  // auth: {
  //   authority: 'https://ahmwebappqas.b2clogin.com/ahmwebappqas.onmicrosoft.com/B2C_1_SI_B2B_QAS',
  //   knownAuthorities: ['ahmwebappqas.b2clogin.com'],
  //   clientId: 'a38cd97c-cc23-4cc3-a2bc-3b6f6a2fddc5',
  //   redirectUri: REDIRECT_URLS[process.env.NODE_ENV],
  //   postLogoutRedirectUri: REDIRECT_URLS[process.env.NODE_ENV],
  // },
  // },
  // PRD: {
  auth: {
    authority: 'https://ahmwebappprod.b2clogin.com/ahmwebappprod.onmicrosoft.com/B2C_1_SI_B2B_PROD',
    knownAuthorities: ['ahmwebappprod.b2clogin.com'],
    clientId: 'c3bd33ea-6898-4eb4-b395-ea5aea781924',
    redirectUri: REDIRECT_URLS[process.env.NODE_ENV],
    postLogoutRedirectUri: REDIRECT_URLS[process.env.NODE_ENV],
  },
  // },
};

const loginRequest = {
  // scopes: ['https://intellisoftb2btest.b2clogin.com/helloapi/api/read openid'],
  scopes: ['openid', 'profile'],
};
export { systemIPOptions, loginRequest, msalConfig };
